import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { SubStatusesService } from '../sub-statuses/sub-statuses.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'sub-status-date',
    templateUrl: './sub-status-date.component.html',
    styleUrls: ['./sub-status-date.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SubStatusDateComponent {
  public projectSubstatusDates: any[] | null;
  @Input() substatus: any;
  @Input() subsequence: any;
  @Input() project_status_id: number;
  @Input() editMode: boolean;
  public substatusDate: any;
  public substatusDatesSub: Subscription;

  constructor(public substatusService: SubStatusesService) {}
  ngOnInit() {
    this.substatusDatesSub = this.substatusService
      .getProjectSubstatusDates()
      .subscribe((projectSubstatusDates) => {
        this.projectSubstatusDates = projectSubstatusDates;
        this.substatusDate = this.projectSubstatusDates?.find(
          (projectSubstatusDate: any) =>
            projectSubstatusDate.subsequence_id === this.subsequence.id &&
            projectSubstatusDate.substatus_id === this.substatus.id &&
            projectSubstatusDate.project_status_id === this.project_status_id
        );
      });
  }
}
